export default {
  RENTAL: "rental",
  RESIDENT: "resident",
  PROPERTY: "property",
};
